<!-- PRINT -->
<div *ngIf="block" class="container-general-print-header px-4">
    <div class="image">
        <img loading="lazy" *ngIf="block.field_immagine" [src]="imgPath" alt="image-hero">
    </div>
    <div>
        <p *ngIf="block.tipo_di_corso" class="ls-p text-brand-10" [innerHTML]="block.tipo_di_corso"></p>
        <p *ngIf="titlePage" class="ls-h3-item-p-title text-brand-10" [innerHTML]="titlePage"></p>
    </div>
</div>
<!-- HEADER PRIMO LIVELLO -->
<div>
    <div *ngIf="block && !isSecondLevelUp && node && (node.field_elimina_visualizzazione_vi && node.field_elimina_visualizzazione_vi.length && !node.field_elimina_visualizzazione_vi[0].value)"
        class="container-page-general position-relative no-print" [ngClass]="{
        'bg-overlay': !isSecondLevelUp && block.field_immagine,
        'height-hero-image': !isSecondLevelUp && block.field_immagine,
        'height-hero-noImage': !isSecondLevelUp && !block.field_immagine
    }">
        <div class="container-page-general__general position-relative d-flex flex-column align-items-center justify-content-between h-100"
            [ngClass]="{'drop-shadow': !isSecondLevelUp && !block.field_immagine}">
            <app-breadcrumb *ngIf="!isSecondLevelUp && !block.field_immagine" 
                [levelMenu]="levelMenu" [isSecondLevelUp]="!isSecondLevelUp && !block.field_immagine"
                [ngClass]="{'position-absolute container-breadcrumb': node.type[0].target_id === 'pagina' && (levelMenu.length === 1)}"
                class="container-page-general__general__breadcrumb mt-2">
            </app-breadcrumb>
            <app-breadcrumb *ngIf="!isSecondLevelUp && block.field_immagine" 
                [levelMenu]="levelMenu" [isSecondLevelUp]="isSecondLevelUp"
                [ngClass]="{'position-absolute container-breadcrumb': node.type[0].target_id === 'pagina' && (levelMenu.length === 1)}"
                class="container-page-general__general__breadcrumb mt-2">
            </app-breadcrumb>
            <img loading="lazy" *ngIf="block.field_immagine" class="position-absolute" [src]="imgPath" alt="image-hero">
            <div *ngIf="!isSecondLevelUp" class="container-page-general__general__title w-100 text-md-center">
                <h1 *ngIf="titlePage" class="ls-h1-page-title" [innerHTML]="titlePage"
                    [ngClass]="!block.field_immagine ? 'text-brand-10' : 'text-neutral-A1'"></h1>
                <p *ngIf="block.field_sottotitolo" class="ls-p" [innerHTML]="block.field_sottotitolo"
                    [ngClass]="!block.field_immagine ? 'text-neutral-50' : 'text-neutral-80'">
                </p>
            </div>
        </div>
        <div *ngIf="!isSecondLevelUp && block.field_immagine"
            class="container-page-general__container-anchor w-100 text-white position-absolute w-100"
            style="bottom: 70px; padding: 0 10px;">
            <app-sample-anchor *ngIf="anchorItems" [anchorItems]="anchorItems" [idAnchor]="idAnchor"
                [color]="!block.field_immagine ? '#02180F' : '#ffffff'" [positionType]="'position-sticky'"
                [positionTop]="'120px'" [bgColor]="'transparent'" [setOffset]="250" [styleHeader]="'first'">
            </app-sample-anchor>
        </div>
        <ng-container *ngIf="!isSecondLevelUp && block.field_immagine">
            <div class="container-page-general__container-share cursor-pointer" (mouseenter)="onHoverShare = true"
                (mouseleave)="onHoverShare = false" (click)="nodeService.openModaleShare()">
                <p class="m-0 ls-label-medium-semibold text-uppercase">{{"MODAL_SHARE.SEND_TO" | translate}}</p>
                <img loading="lazy" *ngIf="!onHoverShare" src="../../../../../../assets/images/share-icon/share-icon-white.png"
                    alt="share icon">
                <img loading="lazy" *ngIf="onHoverShare" src="../../../../../../assets/images/share-icon/share-icon-yellow.png"
                    alt="share icon">
            </div>
            <div class="container-page-general__container-share-icon cursor-pointer"
                (click)="nodeService.openModaleShare()">
                <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-white.png" alt="share icon">
            </div>
        </ng-container>
        <ng-container *ngIf="!isSecondLevelUp && !block.field_immagine">
            <div class="container-header-no-image__container-share cursor-pointer" (mouseenter)="onHoverShare = true"
                (mouseleave)="onHoverShare = false" (click)="nodeService.openModaleShare()">
                <p class="m-0 ls-label-medium-semibold text-uppercase">{{"MODAL_SHARE.SEND_TO" | translate}}</p>
                <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon">
            </div>
            <div class="container-header-no-image__container-share-icon cursor-pointer"
                (click)="nodeService.openModaleShare()">
                <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon">
            </div>
        </ng-container>
    </div>
</div>
<ng-container *ngIf="block && anchorItems && !block.field_immagine && !isSecondLevelUp">
    <!-- Anchor -->
    <div class="mt-4">
        <app-sample-anchor [anchorItems]="anchorItems"
            [idAnchor]="idAnchor" [positionType]="'position-sticky'" [bgColor]="'white'" [setOffset]="120"
            [positionTop]="'125px'" [styleHeader]="'second'">
        </app-sample-anchor>
    </div>
    <!-- END Anchor -->
</ng-container>
<!-- HEADER COLLAPSE -->
<div *ngIf="block && !isSecondLevelUp && node && (node.field_elimina_visualizzazione_vi && node.field_elimina_visualizzazione_vi.length && !node.field_elimina_visualizzazione_vi[0].value)" id="collapse" [ngClass]="{
    'opacity-100 visible bg-neutral-A1': isCollapseHeader,
    'opacity-0 invisible bg-neutral-99': !isCollapseHeader
}" class="container-page-general-collapse position-fixed no-print">
    <div class="container-page-general-collapse__item text-md-center d-flex justify-content-between align-items-center border-bottom-custom">
        <div *ngIf="isShowLocalMenu" class="d-flex align-items-end container-icon-expand m-auto col-1">
            <img loading="lazy" *ngIf="isSecondLevelUp" class="cursor-pointer hidden-phone"
                src="../../../../../../assets/images/side-menu-expand.svg" alt="menu expand" style="margin-left: 34px;"
                (click)="openMenu()">
        </div>
        <p *ngIf="titlePage" class="ls-h1-page-title-collapse mb-0 col-10" [ngClass]="{'offset-md-1': !isShowLocalMenu}"
            [innerHTML]="titlePage">
    </p>
        <!-- <h1 *ngIf="titlePage" class="ls-h1-page-title-collapse offset-md-1 col-10" [innerHTML]="titlePage"></h1> -->
        <div class="d-flex justify-content-end align-items-center col-1" [ngClass]="{
        'col-1': titlePage && isShowLocalMenu,
        'col-11': !titlePage && isShowLocalMenu,
        'col-12': !titlePage && !isShowLocalMenu
    }">
            <div class="cursor-pointer" (click)="nodeService.openModaleShare()">
                <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon"
                    style="margin-right: 34px;">
            </div>
        </div>
    </div>
    <div *ngIf="!isSecondLevelUp && anchorItems.length" class="border-bottom-custom" style="padding: 16px 10px;">
        <app-sample-anchor *ngIf="anchorItems" [anchorItems]="anchorItems" [positionTop]="'140px'" [setOffset]="250"
            [styleHeader]="'collapse'">
        </app-sample-anchor>
    </div>
</div>
<!-- END HEADER COLLAPSE -->
<!-- END HEADER PRIMO LIVELLO -->
<!-- HEADER SECONDO LIVELLO -->
<div *ngIf="block && isSecondLevelUp" class="position-relative" id="collapse-2">
    <div class="container-header-second-level offset-md-2 col-md-8 p-2 p-md-0 position-relative mtop-negative-title">
        <div class="d-flex justify-content-between">
            <div class="title-second text-center w-100">
                <h1 *ngIf="block.field_titolo" class="ls-h1-page-title text-brand-10 text-start text-lg-center px-3 px-lg-0 mb-4" [innerHTML]="titlePage"></h1>
                <p *ngIf="block.field_sottotitolo" class="ls-p text-start text-lg-center text-neutral-40" [innerHTML]="block.field_sottotitolo"></p>
            </div>
            <div class="d-flex justify-content-end">
                <div class="container-header-second-level__container-share-icon hidden-web cursor-pointer m-2"
                    (click)="nodeService.openModaleShare()">
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon">
                </div>
            </div>
        </div>
        <div class=" max-width">
            <img loading="lazy" *ngIf="block.field_immagine && imgPath" class="image-second-level" [src]="imgPath" alt="image-hero">
        </div>
    </div>
    <div class="container-header-second-level__container-share cursor-pointer hidden-phone"
        (mouseenter)="onHoverShare = true" (mouseleave)="onHoverShare = false" (click)="nodeService.openModaleShare()">
        <p class="m-0 ls-label-medium-semibold text-uppercase">{{"MODAL_SHARE.SEND_TO" | translate}}</p>
        <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon">
    </div>
</div>
<ng-container *ngIf="node && block && isSpinner; else spinner">
    <ng-container *ngIf="isSecondLevelUp">
        <div class="container-field-taxonomies">
            <ng-container *ngFor="let contentType of contentTypes">
                <ng-container *ngIf="contentType.condition">
                    <app-container-field-taxonomies [dataFieldTaxonomies]="contentType.data" [typeOfContent]="contentType.type">
                    </app-container-field-taxonomies>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>    
    <!-- Anchor -->
    <div *ngIf="isSecondLevelUp" class="w-100 mt-2">
        <app-sample-anchor *ngIf="anchorItems" [anchorItems]="anchorItems" [idAnchor]="idAnchor"
            [positionType]="'position-block'" [bgColor]="'transparent'" [setOffset]="120" [styleHeader]="'second'">
        </app-sample-anchor>
    </div>
    <!-- END Anchor -->
    <!-- HEADER COLLAPSE -->
    <div *ngIf="block && isSecondLevelUp" [ngClass]="{
        'opacity-100 visible bg-neutral-A1': isCollapseHeader2,
        'opacity-0 invisible bg-neutral-99': !isCollapseHeader2
        }" class="container-header-second-level-collapse position-fixed no-print">
        <div class="container-header-second-level-collapse__item text-md-center d-flex justify-content-between align-items-center border-bottom-custom">
            <div *ngIf="isShowLocalMenu" class="d-flex align-items-end container-icon-expand m-auto col-1">
                <img loading="lazy" *ngIf="isSecondLevelUp" class="cursor-pointer hidden-phone"
                    src="../../../../../../assets/images/side-menu-expand.svg" alt="menu expand"
                    style="margin-left: 34px;" (click)="openMenu()">
            </div>
            <p *ngIf="titlePage" class="ls-h1-page-title-collapse col-10 mb-1" [ngClass]="{'offset-md-1': !isShowLocalMenu}"
                [innerHTML]="titlePage">
        </p>
            <!-- <h1 *ngIf="titlePage" class="ls-h1-page-title-collapse offset-md-1 col-10" [innerHTML]="titlePage"></h1> -->
            <div class="d-flex justify-content-end align-items-center col-1" [ngClass]="{
                'col-1': titlePage && isShowLocalMenu,
                'col-11': !titlePage && isShowLocalMenu,
                'col-12': !titlePage && !isShowLocalMenu
            }">
                <div class="cursor-pointer" (click)="nodeService.openModaleShare()">
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon"
                        style="margin-right: 34px;">
                </div>
            </div>
        </div>
        <div *ngIf="isSecondLevelUp && anchorItems.length" class="border-bottom-custom" style="padding: 10px 0;">
            <app-sample-anchor *ngIf="anchorItems" [anchorItems]="anchorItems" [styleHeader]="'collapse'"
                [positionTop]="'140px'" [setOffset]="280">
            </app-sample-anchor>
        </div>
    </div>
    <!-- END HEADER COLLAPSE -->
    <!-- END HEADER SECONDO LIVELLO -->
    <ng-container *ngIf="node.field_layout_righe && node.field_layout_righe.length">
        <div class="container-row">
            <div *ngFor="let row of rows; let idx = index">
                <app-row [lang]="node.langcode[0].value" [rowId]="row.target_id" [position]="idx" [attr.rowid]="row.target_id"
                    [preview]="node.preview" (objAnchor)="addNewAnchorItem($event)">
                </app-row>
            </div>
        </div>
    </ng-container>
</ng-container>
<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>